const { connect } = require('react-redux');
import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Modal } from 'components';
import { browserHistory } from 'react-router';
import { PortalPageSection } from 'components/PortalStructure';
import { IUserPreferences } from 'models/user/userpreferences';
import { IStore } from 'redux/IStore';

require('./style.css');

interface IProps {
	showHeaderCloseButton?: boolean;
	closeModal?: () => void;
	t?: (key: string) => string;
	baseUrlClient?: string;
	userPreferences?: IUserPreferences;
}

@connect((state: IStore) => ({
	userPreferences: state.userPreferences,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LogInSuccessModal extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.closeModal = this.closeModal.bind(this);
		this.viewMyProfile = this.viewMyProfile.bind(this);
	}

	public closeModal() {
		this.props.closeModal();
	}

	public viewMyProfile() {
		this.closeModal();
		const url = '/profile/' + this.props.userPreferences.code;
		browserHistory.push(url);
	}

	public render() {
		const { t, showHeaderCloseButton } = this.props;

		return (
			<Modal showHeaderCloseButton={showHeaderCloseButton} closeModal={this.closeModal} modalClass="logInSuccessModal">
				<PortalPageSection>
					<div className="body">
						<div className="col-md-4 item">
							<div className="top">
								<div className="icon">
									<img src={require('containers/Html/icons/login_success_icon.svg')} />
								</div>
							</div>
							<div className="bottom">
								<h2 className="header">{t('Login_Modals_LogInSuccess_GreatStuff')}</h2>
								<h3 className="subtitle">{t('Login_Modals_LogInSuccess_GreatStuff_Desc')}</h3>
								<button type="button" className="viewProfile" onClick={this.viewMyProfile}>
									{t('Login_Modals_LogInSuccess_ViewMyProfile')}
								</button>
							</div>
						</div>
					</div>
				</PortalPageSection>
			</Modal>
		);
	}
}
export { LogInSuccessModal };
